import {CommandBase} from "./commandBase";
import {RemoteConstantsModel} from "../models/remoteConstants.model";

export class RemoveBuildingPassiveRewardCommand extends CommandBase {
    buildingId: string;
    rewardUid: string;

    constructor(buildingId: string, rewardUid: string) {
        super();
        this.buildingId = buildingId;
        this.rewardUid = rewardUid;
    }

    execute(data: RemoteConstantsModel): boolean {
        const building = data.buildings.find(b => b.id === this.buildingId);
        if (!building) return false;
        const before = building.passiveRewards?.length ?? 0;
        building.passiveRewards = (building.passiveRewards ?? []).filter(r => r.uid !== this.rewardUid);
        return building.passiveRewards.length !== before;
    }
}
